    /*

  theme.scss.liquid

  
  */

function utf8_to_b64( str ) {
  return window.btoa(encodeURIComponent( str ));
}

function b64_to_utf8( str ) {
  return decodeURIComponent(window.atob( str ));
}

function renderInputOutsideShadowRoot(container,name,value) {
  
  let input = container.querySelector("input.hidden-input");
  if (!input) {
      input = container.ownerDocument.createElement("input");
      input.type = "hidden";
      input.classList.add("hidden-input");
      input.setAttribute('form','cart');
      container.appendChild(input);
  }
  input.name = name;
  input.value = value || "";

  return input;
}


/**
 * Cookie functions
 * @param {*} name 
 * @param {*} url 
 * @returns 
 */
function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

localStorage.setItem('JobID', getParameterByName('j',null) ); 
localStorage.setItem('SubscriberID', getParameterByName('sfmc_sub',null)); 
localStorage.setItem('ListID', getParameterByName('l',null)); 
localStorage.setItem('UrlID', getParameterByName('u',null)); 
localStorage.setItem('MemberID', getParameterByName('mid',null)); 
localStorage.setItem('BatchID', getParameterByName('jb',null) ); 

var maxi_agent = getParameterByName('maxi-link',null);
if (maxi_agent !== null) {
  localStorage.setItem('maxi_agent', maxi_agent );  
}

var agent_type = getParameterByName('agent-type',null);
if (agent_type !== null) {
  localStorage.setItem('agent_type', agent_type );  
}

var agent_name = getParameterByName('agent-name',null);
if (agent_name !== null) {
  localStorage.setItem('agent_name', agent_name );  
}


/*
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
  if (cvalue !== null) { 
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
}

function getCookie(cValue) {
  var name = cValue + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}


setCookie('JobID', getParameterByName('j',null),1  ); 
setCookie('SubscriberID', getParameterByName('sfmc_sub',null),1 ); 
setCookie('ListID', getParameterByName('l',null),1); 
setCookie('UrlID', getParameterByName('u',null),1); 
setCookie('MemberID', getParameterByName('mid',null),1); 
setCookie('BatchID', getParameterByName('jb',null),1 ); 

setCookie('maxi_agent', getParameterByName('maxi_agent',null),1 );

*/

